let achievements = [
    {
        year: 2026
    },
    {
        year: 2026,
        boat: "Barka",
        title: "RoboBoat",
        position: 0,
        award: "homepage.achievements.innovation_prize",
        country: "homepage.achievements_list.usa",
    },
    {
        year: 2026,
        boat: "Celka AI",
        title: "Monaco Energy Boat Challenge",
        position: 4,
        country: "homepage.achievements_list.monako",
    },
    {
        year: 2026,
        boat: "Delta",
        title: "Kraków Solar Boat Challenge",
        position: 1,
        country: "homepage.achievements_list.poland",
    },
    {
        year: 2026,
        boat: "Delta",
        title: "Kraków Solar Boat Challenge",
        position: 0,
        award: "homepage.achievements.innovation_prize",
        country: "homepage.achievements_list.poland",
    },
    {
        year: 2026,
        boat: "Barka",
        title: "The Autonomous Ship Challenge Njord",
        position: 3,
        country: "homepage.achievements_list.norway",
    },
    {
        year: 2026,
        boat: "Delta",
        title: "CoreComm Balaton Solar Boat Challenge",
        position: 6,
        country: "homepage.achievements_list.hungary",
    },
    {   
        year: 2025
    },
    {
        year: 2025,
        boat: "Barka",
        title: "RoboBoat",
        position: 3,
        country: "homepage.achievements_list.usa",
    },
    {
        year: 2025,
        boat: "Celka AI",
        title: "KOKOS",
        position: -3,
        country: "homepage.achievements_list.poland",
    },
    {
        year: 2025,
        boat: "Celka AI",
        title: "Monaco Energy Boat Challenge",
        position: 2,
        country: "homepage.achievements_list.monako",
    },
    {
        year: 2025,
        boat: "Barka",
        title: "The Autonomous Ship Challenge Njord",
        position: 2,
        country: "homepage.achievements_list.norway",
    },
    {
        year: 2025,
        boat: "Celka",
        title: "CoreComm Balaton Solar Boat Challenge",
        position: 6,
        country: "homepage.achievements_list.hungary",
    },
    {
        year: 2024
    },
    {
        year: 2024,
        boat: "Celka",
        title: "Sardinia Innovative Boat Week",
        position: 1,
        country: "homepage.achievements_list.italy"

    },
    {
        year: 2024,
        boat: "Barka",
        title: "KOKOS",
        position: -2,
        country: "homepage.achievements_list.poland"
    },
    {
        year: 2024,
        boat: "Barka",
        title: "The Autonomous Ship Challenge Njord",
        country: "homepage.achievements_list.norway",
        position: 3
    },
    {
        year: 2024,
        boat: "Celka",
        title: "Monaco Energy Boat Challenge",
        country: "homepage.achievements_list.monako",
        position: 3
    },
    {
        year: 2024,
        boat: "Barka",
        title: "RoboBoat",
        country: "homepage.achievements_list.usa",
        position: 2
    },
    {
        year: 2023
    },
    {
        year: 2023,
        boat: "Barka",
        title: "Struna Tech",
        country: "homepage.achievements_list.poland",
        position: 1
    },
    {
        year: 2023,
        boat: "Celka",
        title: "CoreComm Balaton Solar Boat Challenge",
        country: "homepage.achievements_list.hungary",
        position: 7
    },
    {
        year: 2023,
        boat: "Celka",
        title: "Monaco Energy Boat Challenge",
        country: "homepage.achievements_list.monako",
        position: 5
    },
    {
        year: 2023,
        boat: "Celka",
        title: "New Energy Regatta",
        country: "homepage.achievements_list.netherlands",
        position: 6
    },
    {
        year: 2023,
        boat: "Barka",
        position: -1,
        country: "homepage.achievements_list.usa",
        title: "RoboBoat",
    },
    {
        year: 2022
    },
    // {
    //     year: 2022,
    //     title: "Monaco Energy Boat Challenge",
    //     // position: 9,
    //     country: "homepage.achievements_list.monako",
    //     boat: "Celka"
    // },
    // {
    //     year: 2022,
    //     title: "Solarboat Regatta Der Th-Wildau",
    //     country: "homepage.achievements_list.germany",
    //     // position: 8,
    //     boat: "Celka"
    // },
    {
        position: 0,
        title: 'RoboBoat',
        country: "homepage.achievements_list.usa",

        year: 2022,
        boat: "R.O.B.U.R"
    },
    {
        year: 2021
    },
    {
        position: 2,
        title: 'SolarBoat Regatta der Th-Wildau',
        country: "homepage.achievements_list.germany",

        year: 2021,
        boat: "Celka"
    },
    {
        position: 4,
        title: 'Monako Energy Boat Challenge',
        country: "homepage.achievements_list.monako",

        year: 2021,
        boat: "Celka"
    },
    
    {
        position: 5,
        title: 'WATER - World Forum For Life, Portugal',
        country: "homepage.achievements_list.portugal",

        year: 2021,
        boat: "Celka"
    },
    {
        year: 2019
    },
    {
        position: 3,
        title: 'Monaco Solar & Energy Boat Challenge',
        country: "homepage.achievements_list.monako",

        year: 2019,
        boat: "Baśka"
    },
    {
        position: 2,
        title: 'Solarboot Regatta der Th-Wildau',
        country: "homepage.achievements_list.germany",

        year: 2019,
        boat: "Baśka"
    },
    {
        year: 2018
    },
    {
        position: 1,
        title: "ProJuvenes",
        country: "homepage.achievements_list.poland",

        year: 2018
    },
    {
        position: 3,
        title: 'Monaco Solar & Energy Boat Challenge',
        country: "homepage.achievements_list.monako",

        year: 2018,
        boat: "Baśka"
    },
    {
        position: 3,
        title: 'Solarboot Regatta der Th-Wildau',
        country: "homepage.achievements_list.germany",

        year: 2018,
        boat: "Baśka"
    },
    {
        year: 2017
    },
    {
        position: 5,
        title: 'Monaco Solar & Electric Boat Challenge',
        country: "homepage.achievements_list.monako",

        year: 2017,
        boat: "Baśka"
    },
    
    
]

// achievements.reverse()

export default achievements
